import { MultiSelect } from '../../components/ui'

type GroupItem = {
  id: string
  name: string
  count: number
}

type GroupSelectProps = {
  groups: GroupItem[]
  selectedIds: string[]
  onChange: (ids: string[]) => void
  placeholder: string
  emptyText: string
}

export const GroupSelect = ({
  groups,
  selectedIds,
  onChange,
  placeholder,
  emptyText
}: GroupSelectProps) => (
  <MultiSelect
    emptyText={emptyText}
    onChange={onChange}
    options={groups.map((group) => ({
      count: group.count,
      id: group.id,
      label: group.name
    }))}
    placeholder={placeholder}
    selectedIds={selectedIds}
  />
)
